<template>
  <div class="inventory-header inventory-header--glass">
    <div class="inventory-header-row">
      <div class="inventory-header-breadcrumb">
        <button class="inventory-header-back-btn" type="button" aria-label="Go back" title="Back" @click="goBack">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
        </button>
        <a href="#">Home</a> &gt; <a href="#">Inventory</a> &gt; Inventory Centre
      </div>
    </div>

    <div class="inventory-header-filters">
      <div class="inventory-header-filters-group">
        <LabelDropdown
          label="Status"
          select-id="inventory-status"
          v-model="localInventoryFilter"
          inline
          :searchable="false"
          :options="statusOptions"
        />
      </div>

      <div class="inventory-header-actions">
        <SecondaryButton
          label="Export to CSV"
          icon="bi bi-download"
          custom-class="inventory-header-export-btn"
          @click="exportToCsv"
        />
        <PrimaryButton
          label="Add A New Inventory Item"
          icon="bi bi-plus-lg"
          @click="goToAddInventoryItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LabelDropdown from '@/modules/consultant/components/LabelDropdown.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'InventoryHeader',
  components: { LabelDropdown, PrimaryButton, SecondaryButton },
  props: {
    inventoryFilter: {
      type: String,
      default: 'active',
    },
  },
  emits: ['filter-changed'],
  data() {
    return {
      localInventoryFilter: this.inventoryFilter,
    };
  },
  computed: {
    statusOptions() {
      return [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ];
    },
  },
  methods: {
    goToAddInventoryItem() {
      const companyId = this.$route.params.id;
      this.$router.push(`/company/${companyId}/dashboard/inventory/new-item`);
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        const companyId = this.$route.params.id;
        this.$router.push(`/company/${companyId}/dashboard/overview`);
      }
    },
    exportToCsv() {
      this.$toast?.info?.('Export to CSV') || alert('Export to CSV');
    },
  },
  watch: {
    localInventoryFilter(newVal) {
      if (newVal !== this.inventoryFilter) {
        this.$emit('filter-changed', newVal);
      }
    },
    inventoryFilter(newVal) {
      this.localInventoryFilter = newVal;
    },
  },
};
</script>

<style scoped>
@import '../styles/InventoryHeader.css';
@import '../styles/inventory-header-glass.css';
</style>
